package io.github.kingsword09.symbolcraft.symbols.icons.`simple-icons`.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.`simple-icons`.Icons

public val Icons.EpicgamesSimpleIcons: ImageVector
    get() {
        if (_epicgamesSimpleIcons != null) {
            return _epicgamesSimpleIcons!!
        }
        _epicgamesSimpleIcons = Builder(name = "EpicgamesSimpleIcons", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 24.0f, viewportHeight = 24.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(3.54f, 0.0f)
                curveTo(2.17f, 0.0f, 1.66f, 0.51f, 1.66f, 1.88f)
                lineTo(1.66f, 18.44f)
                arcToRelative(4.26f, 4.26f, 0.0f, false, false, 0.02f, 0.43f)
                curveToRelative(0.03f, 0.3f, 0.04f, 0.59f, 0.32f, 0.92f)
                curveToRelative(0.03f, 0.03f, 0.31f, 0.25f, 0.31f, 0.25f)
                curveToRelative(0.15f, 0.08f, 0.26f, 0.13f, 0.43f, 0.2f)
                lineToRelative(8.34f, 3.49f)
                curveToRelative(0.43f, 0.20f, 0.61f, 0.28f, 0.93f, 0.27f)
                horizontalLineToRelative(0.00f)
                curveToRelative(0.31f, 0.01f, 0.50f, -0.07f, 0.93f, -0.27f)
                lineToRelative(8.34f, -3.49f)
                curveToRelative(0.17f, -0.07f, 0.28f, -0.12f, 0.43f, -0.2f)
                curveToRelative(0.0f, 0.0f, 0.28f, -0.21f, 0.31f, -0.24f)
                curveToRelative(0.28f, -0.33f, 0.29f, -0.62f, 0.32f, -0.92f)
                arcToRelative(4.26f, 4.26f, 0.0f, false, false, 0.02f, -0.43f)
                lineTo(22.34f, 1.88f)
                curveToRelative(0.0f, -1.37f, -0.51f, -1.88f, -1.88f, -1.88f)
                close()
                moveTo(16.90f, 3.11f)
                horizontalLineToRelative(0.68f)
                curveToRelative(1.14f, 0.0f, 1.69f, 0.55f, 1.69f, 1.70f)
                verticalLineToRelative(1.88f)
                horizontalLineToRelative(-1.37f)
                verticalLineToRelative(-1.8f)
                curveToRelative(0.0f, -0.37f, -0.17f, -0.54f, -0.52f, -0.54f)
                horizontalLineToRelative(-0.24f)
                curveToRelative(-0.37f, 0.0f, -0.54f, 0.17f, -0.54f, 0.54f)
                verticalLineToRelative(5.81f)
                curveToRelative(0.0f, 0.37f, 0.17f, 0.54f, 0.54f, 0.54f)
                horizontalLineToRelative(0.26f)
                curveToRelative(0.35f, 0.0f, 0.52f, -0.17f, 0.52f, -0.54f)
                lineTo(17.92f, 8.62f)
                horizontalLineToRelative(1.37f)
                verticalLineToRelative(2.14f)
                curveToRelative(0.0f, 1.14f, -0.56f, 1.71f, -1.7f, 1.71f)
                horizontalLineToRelative(-0.69f)
                curveToRelative(-1.14f, 0.0f, -1.7f, -0.57f, -1.7f, -1.71f)
                lineTo(15.20f, 4.82f)
                curveToRelative(0.0f, -1.14f, 0.56f, -1.71f, 1.7f, -1.71f)
                close()
                moveTo(4.72f, 3.19f)
                horizontalLineToRelative(3.11f)
                verticalLineToRelative(1.27f)
                lineTo(6.12f, 4.46f)
                verticalLineToRelative(2.60f)
                horizontalLineToRelative(1.65f)
                verticalLineToRelative(1.28f)
                lineTo(6.12f, 8.34f)
                verticalLineToRelative(2.77f)
                horizontalLineToRelative(1.74f)
                verticalLineToRelative(1.28f)
                horizontalLineToRelative(-3.14f)
                close()
                moveTo(8.53f, 3.19f)
                horizontalLineToRelative(2.20f)
                curveToRelative(1.14f, 0.0f, 1.7f, 0.56f, 1.7f, 1.71f)
                verticalLineToRelative(2.45f)
                curveToRelative(0.0f, 1.14f, -0.56f, 1.71f, -1.7f, 1.71f)
                horizontalLineToRelative(-0.80f)
                verticalLineToRelative(3.34f)
                horizontalLineToRelative(-1.4f)
                close()
                moveTo(13.06f, 3.19f)
                horizontalLineToRelative(1.4f)
                verticalLineToRelative(9.20f)
                horizontalLineToRelative(-1.4f)
                close()
                moveTo(9.93f, 4.43f)
                verticalLineToRelative(3.39f)
                horizontalLineToRelative(0.58f)
                curveToRelative(0.35f, 0.0f, 0.52f, -0.17f, 0.52f, -0.54f)
                lineTo(11.03f, 4.97f)
                curveToRelative(0.0f, -0.37f, -0.17f, -0.54f, -0.52f, -0.54f)
                close()
                moveTo(6.19f, 14.57f)
                arcToRelative(1.71f, 1.71f, 0.0f, false, true, 0.59f, 0.11f)
                arcToRelative(1.75f, 1.75f, 0.0f, false, true, 0.49f, 0.30f)
                lineToRelative(-0.45f, 0.55f)
                arcToRelative(1.25f, 1.25f, 0.0f, false, false, -0.31f, -0.20f)
                arcToRelative(0.91f, 0.91f, 0.0f, false, false, -0.36f, -0.07f)
                arcToRelative(0.66f, 0.66f, 0.0f, false, false, -0.28f, 0.06f)
                arcToRelative(0.70f, 0.70f, 0.0f, false, false, -0.22f, 0.16f)
                arcToRelative(0.78f, 0.78f, 0.0f, false, false, -0.15f, 0.24f)
                arcToRelative(0.80f, 0.80f, 0.0f, false, false, -0.06f, 0.30f)
                verticalLineToRelative(0.01f)
                arcToRelative(0.85f, 0.85f, 0.0f, false, false, 0.06f, 0.31f)
                arcToRelative(0.7f, 0.7f, 0.0f, false, false, 0.16f, 0.25f)
                arcToRelative(0.74f, 0.74f, 0.0f, false, false, 0.24f, 0.16f)
                arcToRelative(0.77f, 0.77f, 0.0f, false, false, 0.30f, 0.06f)
                arcToRelative(0.79f, 0.79f, 0.0f, false, false, 0.45f, -0.12f)
                verticalLineToRelative(-0.34f)
                horizontalLineToRelative(-0.55f)
                verticalLineToRelative(-0.57f)
                lineTo(7.37f, 15.79f)
                verticalLineToRelative(1.26f)
                arcToRelative(2.02f, 2.02f, 0.0f, false, true, -0.52f, 0.31f)
                arcToRelative(1.79f, 1.79f, 0.0f, false, true, -0.68f, 0.12f)
                arcToRelative(1.64f, 1.64f, 0.0f, false, true, -0.60f, -0.11f)
                arcToRelative(1.46f, 1.46f, 0.0f, false, true, -0.48f, -0.3f)
                arcToRelative(1.37f, 1.37f, 0.0f, false, true, -0.32f, -0.46f)
                arcToRelative(1.44f, 1.44f, 0.0f, false, true, -0.12f, -0.58f)
                verticalLineToRelative(-0.01f)
                arcToRelative(1.43f, 1.43f, 0.0f, false, true, 0.11f, -0.57f)
                arcToRelative(1.45f, 1.45f, 0.0f, false, true, 0.31f, -0.46f)
                arcToRelative(1.42f, 1.42f, 0.0f, false, true, 0.47f, -0.31f)
                arcToRelative(1.58f, 1.58f, 0.0f, false, true, 0.60f, -0.11f)
                arcToRelative(1.71f, 1.71f, 0.0f, false, true, 0.05f, 0.0f)
                close()
                moveTo(18.16f, 14.58f)
                arcToRelative(2.01f, 2.01f, 0.0f, false, true, 0.61f, 0.09f)
                arcToRelative(1.61f, 1.61f, 0.0f, false, true, 0.51f, 0.28f)
                lineToRelative(-0.39f, 0.55f)
                arcToRelative(1.56f, 1.56f, 0.0f, false, false, -0.39f, -0.21f)
                arcToRelative(1.18f, 1.18f, 0.0f, false, false, -0.39f, -0.07f)
                arcToRelative(0.35f, 0.35f, 0.0f, false, false, -0.21f, 0.05f)
                arcToRelative(0.15f, 0.15f, 0.0f, false, false, -0.07f, 0.13f)
                verticalLineToRelative(0.01f)
                arcToRelative(0.16f, 0.16f, 0.0f, false, false, 0.02f, 0.08f)
                arcToRelative(0.20f, 0.20f, 0.0f, false, false, 0.08f, 0.07f)
                arcToRelative(0.83f, 0.83f, 0.0f, false, false, 0.15f, 0.06f)
                curveToRelative(0.06f, 0.02f, 0.14f, 0.04f, 0.24f, 0.06f)
                arcToRelative(3.39f, 3.39f, 0.0f, false, true, 0.43f, 0.12f)
                arcToRelative(1.29f, 1.29f, 0.0f, false, true, 0.33f, 0.17f)
                arcToRelative(0.68f, 0.68f, 0.0f, false, true, 0.21f, 0.24f)
                arcToRelative(0.74f, 0.74f, 0.0f, false, true, 0.07f, 0.34f)
                verticalLineToRelative(0.01f)
                arcToRelative(0.87f, 0.87f, 0.0f, false, true, -0.08f, 0.38f)
                arcToRelative(0.82f, 0.82f, 0.0f, false, true, -0.23f, 0.29f)
                arcToRelative(1.03f, 1.03f, 0.0f, false, true, -0.35f, 0.18f)
                arcToRelative(1.61f, 1.61f, 0.0f, false, true, -0.46f, 0.06f)
                arcToRelative(2.16f, 2.16f, 0.0f, false, true, -0.71f, -0.12f)
                arcToRelative(1.72f, 1.72f, 0.0f, false, true, -0.59f, -0.35f)
                lineToRelative(0.43f, -0.51f)
                curveToRelative(0.28f, 0.22f, 0.58f, 0.34f, 0.9f, 0.34f)
                arcToRelative(0.46f, 0.46f, 0.0f, false, false, 0.24f, -0.05f)
                arcToRelative(0.16f, 0.16f, 0.0f, false, false, 0.08f, -0.14f)
                verticalLineToRelative(-0.01f)
                arcToRelative(0.15f, 0.15f, 0.0f, false, false, -0.02f, -0.08f)
                arcToRelative(0.20f, 0.20f, 0.0f, false, false, -0.07f, -0.07f)
                arcToRelative(0.75f, 0.75f, 0.0f, false, false, -0.14f, -0.06f)
                arcToRelative(2.45f, 2.45f, 0.0f, false, false, -0.23f, -0.06f)
                arcToRelative(5.04f, 5.04f, 0.0f, false, true, -0.41f, -0.11f)
                arcToRelative(1.26f, 1.26f, 0.0f, false, true, -0.33f, -0.16f)
                arcToRelative(0.72f, 0.72f, 0.0f, false, true, -0.22f, -0.24f)
                arcToRelative(0.73f, 0.73f, 0.0f, false, true, -0.08f, -0.36f)
                verticalLineToRelative(-0.01f)
                arcToRelative(0.86f, 0.86f, 0.0f, false, true, 0.07f, -0.36f)
                arcToRelative(0.79f, 0.79f, 0.0f, false, true, 0.21f, -0.28f)
                arcToRelative(1.01f, 1.01f, 0.0f, false, true, 0.34f, -0.19f)
                arcToRelative(1.42f, 1.42f, 0.0f, false, true, 0.45f, -0.07f)
                arcToRelative(2.01f, 2.01f, 0.0f, false, true, 0.03f, 0.0f)
                close()
                moveTo(8.80f, 14.61f)
                horizontalLineToRelative(0.74f)
                lineToRelative(1.18f, 2.81f)
                horizontalLineToRelative(-0.83f)
                lineToRelative(-0.20f, -0.50f)
                lineTo(8.62f, 16.92f)
                lineToRelative(-0.20f, 0.50f)
                horizontalLineToRelative(-0.81f)
                close()
                moveTo(11.00f, 14.63f)
                horizontalLineToRelative(0.81f)
                lineToRelative(0.66f, 1.08f)
                lineToRelative(0.66f, -1.08f)
                horizontalLineToRelative(0.81f)
                verticalLineToRelative(2.79f)
                horizontalLineToRelative(-0.77f)
                verticalLineToRelative(-1.60f)
                lineToRelative(-0.71f, 1.09f)
                horizontalLineToRelative(-0.02f)
                lineToRelative(-0.71f, -1.08f)
                verticalLineToRelative(1.59f)
                horizontalLineToRelative(-0.75f)
                close()
                moveTo(14.46f, 14.63f)
                horizontalLineToRelative(2.24f)
                verticalLineToRelative(0.66f)
                horizontalLineToRelative(-1.47f)
                verticalLineToRelative(0.42f)
                horizontalLineToRelative(1.33f)
                verticalLineToRelative(0.61f)
                horizontalLineToRelative(-1.33f)
                verticalLineToRelative(0.44f)
                horizontalLineToRelative(1.49f)
                verticalLineToRelative(0.66f)
                horizontalLineToRelative(-2.26f)
                close()
                moveTo(9.16f, 15.52f)
                lineToRelative(-0.32f, 0.79f)
                horizontalLineToRelative(0.62f)
                close()
                moveTo(8.02f, 20.71f)
                horizontalLineToRelative(8.01f)
                lineToRelative(-4.09f, 1.35f)
                close()
            }
        }
        .build()
        return _epicgamesSimpleIcons!!
    }

private var _epicgamesSimpleIcons: ImageVector? = null
